
class CapForceStartRoutePullEntry {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'force_start_route_pull_entry'
}

function create(config) {
  return new CapForceStartRoutePullEntry(config)
}

export default {
  key,
  create,
}
